const {h, render, Component} = require('preact');

class Description extends Component {
  constructor(props) {
    super(props);
  }

  getPlaceholder() {
    let comments_text = I18n.translate('js.modules.web_2018.comments_text')
    let comments_optional = I18n.translate('js.modules.web_2018.comments_optional')
    return (
      comments_text + "\n" +comments_optional
    )
  }

  render() {
    return (
      <div class="refund-text">
              <textarea id="refund-text-area" cols="80" rows="5" maxLength="250" name="description" aria-label="Description"
                        placeholder= {this.getPlaceholder()}>
              </textarea>
      </div>
    )
  }
}

module.exports = Description